import * as React from 'react';
import {withTranslation} from 'react-i18next';
import s from './navigationLink.scss';
import {NavLink} from 'react-router-dom';
import {getTagByPath} from '../../../utils';
import classnames from 'classnames';

type NavigationLinkProps = {
  t?: (...args: any[]) => any;
  hide?: boolean;
  link: any;
  'data-hooks'?: string;
  onClickHandler?: (...args: any[]) => any;
  className?: string;
  HtmlTag?: string;
};

class NavigationLink extends React.Component<NavigationLinkProps, {}> {
  render() {
    const {t, link, hide, onClickHandler = () => {}, className, HtmlTag= 'li'} = this.props;
    const {label, path, tag, show, menuLevel} = link;
    const buttonName = t(label);
    if (!show) {
      return <span />;
    }
    const cls = classnames(
      s.linkWrapper,
      menuLevel ? `navigation-link-level-${menuLevel}` : null,
      className
    );
    const hooks = ['navigation-link', menuLevel && `navigation-link-level-${menuLevel}`].concat(this.props['data-hooks']).filter(item => item).join(' ');
    const Tag: typeof React.Component = HtmlTag as any;
    return (
      // React.createElement(HtmlTag, {className: cls, 'data-hide': hide},
      <Tag className={cls} data-hide={hide}>
        <NavLink
          data-hooks={hooks}
          onClick={e => {
            e.preventDefault;
            onClickHandler(buttonName);
          }}
          to={path}
          isActive={(match, location) => {
            return getTagByPath(location.pathname) === tag;
          }}
          activeClassName={s.active}
          className={s.link}
        >
          {buttonName}
        </NavLink>
      </Tag>
      // )
    );
  }
}
export default withTranslation()(NavigationLink);
